module.exports = __webpack_public_path__ + "img/facebook-f.8b180734.svg";